import api from './config';

export const getGroups = async () => {
    try {
        const token = localStorage.getItem('token');
        if (!token) {
            throw new Error('No authentication token found');
        }

        const response = await api.get('/group', {
            headers: {
                'Authorization': `Bearer ${atob(token)}`
            }
        });

        return response.data;
    } catch (error) {
        throw error.response?.data || error.message;
    }
};

export const getGroup = async (groupId) => {
    try {
        const token = localStorage.getItem('token');
        if (!token) {
            throw new Error('No authentication token found');
        }

        const response = await api.get(`/group/${groupId}`, {
            headers: {
                'Authorization': `Bearer ${atob(token)}`
            }
        });

        return response.data;
    } catch (error) {
        throw error.response?.data || error.message;
    }
};

export const createGroup = async (name, members = []) => {
    try {
        const token = localStorage.getItem('token');
        if (!token) {
            throw new Error('No authentication token found');
        }

        const response = await api.post('/group', {
            name,
            members
        }, {
            headers: {
                'Authorization': `Bearer ${atob(token)}`
            }
        });

        return response.data;
    } catch (error) {
        throw error.response?.data || error.message;
    }
};

export const deleteGroup = async (groupId) => {
    try {
        const token = localStorage.getItem('token');
        if (!token) {
            throw new Error('No authentication token found');
        }

        await api.delete(`/group/${groupId}`, {
            headers: {
                'Authorization': `Bearer ${atob(token)}`
            }
        });
    } catch (error) {
        throw error.response?.data || error.message;
    }
};

export const addMembersToGroup = async (groupId, emails = []) => {
    try {
        const token = localStorage.getItem('token');
        if (!token) {
            throw new Error('No authentication token found');
        }

        await api.post(`/group/${groupId}/members`, {
            emails
        }, {
            headers: {
                'Authorization': `Bearer ${atob(token)}`
            }
        });
    } catch (error) {
        throw error.response?.data || error.message;
    }
};

export const removeMemberFromGroup = async (groupId, userId) => {
    try {
        const token = localStorage.getItem('token');
        if (!token) {
            throw new Error('No authentication token found');
        }

        await api.delete(`/group/${groupId}/members/${userId}`, {
            headers: {
                'Authorization': `Bearer ${atob(token)}`
            }
        });
    } catch (error) {
        throw error.response?.data || error.message;
    }
};

export const acceptGroupInvitation = async (groupId) => {
    try {
        const token = localStorage.getItem('token');
        if (!token) {
            throw new Error('No authentication token found');
        }

        const response = await api.post(`/group/${groupId}/accept`, {}, {
            headers: {
                'Authorization': `Bearer ${atob(token)}`
            }
        });

        return response.data;
    } catch (error) {
        throw error.response?.data || error.message;
    }
};

export const rejectGroupInvitation = async (groupId) => {
    try {
        const token = localStorage.getItem('token');
        if (!token) {
            throw new Error('No authentication token found');
        }

        const response = await api.post(`/group/${groupId}/reject`, {}, {
            headers: {
                'Authorization': `Bearer ${atob(token)}`
            }
        });

        return response.data;
    } catch (error) {
        throw error.response?.data || error.message;
    }
}; 